export default {
  // Nav
  nav_home: 'Inicio',
  nav_features_amenities: 'Características y Comodidades',
  nav_gallery: 'Galería',
  nav_location: 'Ubicación',
  nav_rules: 'Normas',
  nav_book_now: 'Reservar',
  nav_language: 'Idioma',

  // Hero — Home
  hero_home_subtitle: 'Lanzarote · Islas Canarias',
  hero_home_title: 'Villas Yaiza',
  hero_home_tagline: 'Una Experiencia Inolvidable',
  hero_home_villas: '3 Villas Exclusivas',
  hero_home_guests: 'Hasta 4 Huéspedes',
  hero_home_location: 'Yaiza y El Golfo',
  hero_home_authentic: 'Lanzarote Auténtico',
  hero_home_description: 'Descubre nuestra colección de casas vacacionales exclusivas, desde villas de lujo modernas con piscinas privadas hasta casas canarias tradicionales con impresionantes vistas a la laguna.',
  hero_home_explore: 'Explora Nuestras Villas',
  hero_home_check: 'Consultar Disponibilidad',
  hero_home_scroll: 'Desplazar',

  // Hero — Villas (shared keys)
  hero_from: 'Desde',
  hero_night: '/ noche',
  hero_check_availability: 'Consultar Disponibilidad',
  hero_book_now: 'Reservar',
  hero_scroll: 'Desplazar',

  // Search Bar
  search_check_in: 'Entrada',
  search_check_out: 'Salida',
  search_guests: 'Huéspedes',
  search_guest_singular: 'Huésped',
  search_guest_plural: 'Huéspedes',
  search_search: 'Buscar Disponibilidad',
  search_free_cancel: 'Cancelación GRATUITA',
  search_urgency: 'Casi completo. Recomendamos reservar pronto.',
  search_error_dates: 'Por favor, selecciona tu fecha de entrada y salida.',
  search_error_order: 'La fecha de salida debe ser posterior a la de entrada.',
  search_error_generic: 'No pudimos comprobar la disponibilidad. Inténtalo de nuevo.',
  search_checking: 'Comprobando...',
  search_available_single: '¡Disponible para tus fechas!',
  search_not_available_single: 'No disponible para esas fechas. Prueba con otras fechas.',
  search_book_now: 'Reservar ahora',
  villas_available: 'Disponible',
  villas_not_available: 'No disponible para tus fechas',
  villas_no_results: 'Ninguna villa está disponible para las fechas seleccionadas.',
  villas_available_for_dates: 'villas disponibles para tus fechas',

  // Why Choose
  why_title: '¿Por qué elegir Villas Yaiza?',
  why_subtitle: 'Tu escape privado en el corazón de Lanzarote',
  why_p1: 'Villas Yaiza es una colección de casas vacacionales exclusivas, cada una totalmente privada con entornos tranquilos — sin espacios compartidos.',
  why_p2: 'Situado en el encantador pueblo de Yaiza, estás a minutos del Parque Nacional Timanfaya, Playa Blanca, El Golfo y Los Hervideros.',
  why_p3: 'Nuestro equipo local siempre está encantado de compartir consejos de insiders — desde playas escondidas hasta los mejores restaurantes de la isla.',
  why_contact: 'Habla con nuestro equipo:',
  why_phone_label: 'teléfono:',

  // Amenities / Everything you need
  amenities_subtitle: 'Por qué elegirnos',
  amenities_title: 'Todo lo que necesitas',
  feat_private_pool: 'Piscina Privada',
  feat_heated_pool: 'Piscina Climatizada',
  feat_sea_views: 'Vistas al Mar',
  feat_mountain_views: 'Vistas a la Montaña',
  feat_wifi: 'WiFi Rápido',
  feat_parking: 'Aparcamiento Gratuito',
  feat_kitchen: 'Cocina Totalmente Equipada',
  feat_bbq: 'Barbacoa',
  feat_self_checkin: 'Check-in Autónomo',
  feat_workspace: 'Espacio de Trabajo',
  feat_family: 'Familiar',
  feat_garden_terrace: 'Jardín y Terraza',
  feat_traditional: 'Arquitectura Canaria Tradicional',
  feat_green_lagoon: 'Vistas al Mar y Charco Verde',
  feat_private_garden: 'Jardín Privado',

  // Features section
  features_subtitle: 'Lo que ofrece este lugar',
  features_title: 'Características y Comodidades',
  features_title_home: 'Características',
  features_exterior: 'Exterior',
  features_interior: 'Interior',
  features_kitchen: 'Cocina',
  feat_outdoor_shower: 'Ducha Exterior',
  feat_garden: 'Jardín',
  feat_covered_terrace: 'Terraza Cubierta',
  feat_smart_tv: 'TV Inteligente',
  feat_washing: 'Lavadora',
  feat_dryer: 'Secadora',
  feat_dishwasher: 'Lavavajillas',
  feat_heating: 'Calefacción',
  feat_fully_equipped: 'Totalmente Equipada',
  feat_coffee: 'Cafetera',
  feat_kettle: 'Hervidor',
  feat_fridge: 'Frigorífico',
  feat_oven: 'Horno',
  feat_microwave: 'Microondas',
  feat_kitchenware: 'Utensilios de Cocina',
  feat_green_lagoon_views: 'Vistas al Charco Verde',
  feat_ocean_views: 'Vistas al Océano',
  feat_outdoor_dining: 'Comedor Exterior',

  // Our Villas
  villas_subtitle: 'Nuestra Colección',
  villas_title: 'Nuestras Villas',
  villas_description: 'Descubre nuestras casas seleccionadas en Lanzarote. Desde villas de lujo modernas con piscinas privadas hasta casas canarias tradicionales auténticas, cada propiedad ofrece una experiencia única en la isla.',
  villas_from: 'Desde',
  villas_night: '/noche',
  villas_guests: 'Huéspedes',
  villas_bedrooms: 'Dormitorios',
  villas_bathrooms: 'Baños',
  villa_buenlugar_tagline: 'Piscina Privada Climatizada',
  villa_villaflor_tagline: 'Piscina Privada Climatizada',
  villa_golfo_tagline: 'Casa Canaria Tradicional',

  // Layout / Room Distribution
  layout_subtitle: 'Dónde dormirás',
  layout_title: 'Distribución de Habitaciones',
  room_bedroom1: 'Dormitorio 1',
  room_bedroom2: 'Dormitorio 2',
  room_bathrooms: 'Baños',
  room_bathroom: 'Baño',
  bed_double: '1 Cama Doble',
  bed_twin: '2 Camas Individuales',
  bed_queen: '1 Cama Queen',
  bed_bunk: 'Literas',
  bath_2full: '2 Baños Completos',
  bath_1full: '1 Baño Completo',

  // Map / Location
  map_subtitle: 'Dónde estarás',
  map_nearby: 'Lugares Cercanos',

  // Rules
  rules_subtitle: 'Normas de la Casa',
  rules_title: 'Cosas que debes saber',
  rule_no_smoking: 'Prohibido fumar',
  rule_no_parties: 'Prohibidas las fiestas',
  rule_pets_allowed: 'Se admiten mascotas',
  rule_private_entrance: 'Entrada privada',
  rule_calm: 'Zona tranquila',
  rule_family: 'Familiar',
  license_number: 'Número de Licencia',

  // CTA
  cta_buenlugar_title: 'Escapa a la tranquilidad de Lanzarote y disfruta de tu piscina privada climatizada con inolvidables vistas al mar y a la montaña.',
  cta_buenlugar_subtitle: 'Tu retiro de lujo te espera en Yaiza. Reserva ahora y crea recuerdos para toda la vida.',
  cta_villaflor_title: 'Escapa a la tranquilidad de Lanzarote y disfruta de tu piscina privada climatizada con inolvidables vistas al mar y a la montaña.',
  cta_villaflor_subtitle: 'Tu retiro de lujo te espera en Yaiza. Reserva ahora y crea recuerdos para toda la vida.',
  cta_golfo_title: 'Escapa a la belleza salvaje de El Golfo y experimenta la vida canaria auténtica con inolvidables vistas al Charco Verde y al océano.',
  cta_golfo_subtitle: 'Tu retiro canario tradicional te espera. Reserva ahora y descubre el Lanzarote real.',
  cta_home_title: 'Escapa a la tranquilidad de Lanzarote y disfruta de tu piscina privada climatizada con inolvidables vistas al mar y a la montaña.',
  cta_home_subtitle: 'Tu retiro de lujo te espera en Yaiza. Reserva ahora y crea recuerdos para toda la vida.',
  cta_reserve: 'Reserva Tu Estancia',

  // Descriptions
  desc_about: 'Sobre la villa',
  desc_about_golfo: 'Sobre la casa',
  desc_title: 'Tu retiro privado en Lanzarote',
  desc_title_golfo: 'Encanto canario auténtico junto al Atlántico',
  desc_buenlugar_p1: 'Villa Buenlugar ofrece una experiencia relajante en Yaiza, Lanzarote, con capacidad para 4 huéspedes con total comodidad y privacidad.',
  desc_buenlugar_p2: 'La villa cuenta con dos dormitorios bellamente decorados, dos baños completos con accesorios premium, y una cocina totalmente equipada con cafetera italiana, hervidor, lavavajillas y todo lo necesario para preparar comidas memorables.',
  desc_buenlugar_p3: 'Mantente conectado con WiFi de alta velocidad perfecto para videollamadas, disfruta del espacio de trabajo dedicado, relájate con la TV inteligente, y utiliza la calefacción, ventiladores, lavadora, secadora, cuna y trona — todo pensado para tu comodidad.',
  desc_buenlugar_p4: 'La propiedad es totalmente accesible y ofrece check-in autónomo para una llegada sin complicaciones.',
  desc_villaflor_p1: 'Casa De la Villaflor ofrece una experiencia relajante en Yaiza, Lanzarote, con capacidad para 4 huéspedes con total comodidad y privacidad.',
  desc_villaflor_p2: 'La villa cuenta con dos dormitorios bellamente decorados, dos baños completos con accesorios premium, y una cocina totalmente equipada con cafetera italiana, hervidor, lavavajillas y todo lo necesario para preparar comidas memorables.',
  desc_villaflor_p3: 'Mantente conectado con WiFi de alta velocidad perfecto para videollamadas, disfruta del espacio de trabajo dedicado, relájate con la TV inteligente, y utiliza la calefacción, ventiladores, lavadora, secadora, cuna y trona — todo pensado para tu comodidad.',
  desc_villaflor_p4: 'La propiedad es totalmente accesible y ofrece check-in autónomo para una llegada sin complicaciones.',
  desc_golfo_p1: 'Casa de El Golfo es una casa canaria tradicional cuidadosamente restaurada en el corazón de El Golfo, Lanzarote, ofreciendo una experiencia isleña auténtica para hasta 4 huéspedes.',
  desc_golfo_p2: 'La casa cuenta con dos acogedores dormitorios con techos de vigas de madera, un baño completo con acentos de piedra tradicionales, y una cocina totalmente equipada con cafetera italiana, hervidor y todo lo necesario para preparar comidas locales con ingredientes frescos de la isla.',
  desc_golfo_p3: 'Mantente conectado con WiFi de alta velocidad, disfruta del espacio de trabajo dedicado, relájate con la TV inteligente, y utiliza la lavadora, calefacción, ventiladores, cuna y trona — todo pensado para tu comodidad.',
  desc_golfo_p4: 'La propiedad ofrece un jardín privado con zona de barbacoa y comedor exterior, además de impresionantes vistas del icónico Charco Verde y el Océano Atlántico. La propiedad es totalmente accesible y ofrece check-in autónomo para una llegada sin complicaciones.',
  license: 'Licencia',

  // Gallery
  gallery_subtitle: 'Galería de Fotos',
  gallery_title: 'Explora la villa',
  gallery_title_golfo: 'Explora la casa',

  // Footer
  footer_brand: 'Villas Yaiza',
  footer_address: 'Yaiza · Lanzarote\nIslas Canarias, España',
  footer_quick_links: 'Enlaces Rápidos',
  footer_info: 'Información',
  footer_contact: 'Contáctanos',
  footer_availability: 'Disponibilidad',
  footer_amenities: 'Comodidades',
  footer_privacy: 'Política de Privacidad',
  footer_terms: 'Términos y Condiciones',
  footer_license: 'Licencia: E-35-3-0000345',
  footer_name_placeholder: 'Tu Nombre',
  footer_email_placeholder: 'Tu Email',
  footer_message_placeholder: 'Tu Mensaje',
  footer_send: 'Enviar Mensaje',
  footer_sending: 'Enviando...',
  footer_success: '¡Gracias! Tu mensaje ha sido enviado correctamente.',
  footer_error: 'Algo salió mal. Por favor, inténtalo de nuevo.',
  footer_rights: 'Todos los derechos reservados.',

  // Hero specifics
  hero_buenlugar_location: 'Yaiza · Lanzarote · Islas Canarias',
  hero_buenlugar_tagline: 'Piscina Privada Climatizada · Vistas al Mar y a la Montaña',
  hero_buenlugar_guests: '4 Huéspedes',
  hero_buenlugar_beds: '2 Dormitorios',
  hero_buenlugar_baths: '2 Baños',
  hero_buenlugar_size: '120 m² (1,292 ft²)',

  hero_villaflor_location: 'Yaiza · Lanzarote · Islas Canarias',
  hero_villaflor_tagline: 'Villa de Lujo en Yaiza · Lanzarote',
  hero_villaflor_guests: '4 Huéspedes',
  hero_villaflor_beds: '2 Dormitorios',
  hero_villaflor_baths: '2 Baños',
  hero_villaflor_size: '120 m² (1,292 ft²)',

  hero_golfo_location: 'El Golfo · Lanzarote · Islas Canarias',
  hero_golfo_tagline: 'Casa Canaria Auténtica · El Golfo · Lanzarote',
  hero_golfo_guests: '4 Huéspedes',
  hero_golfo_beds: '2 Dormitorios',
  hero_golfo_baths: '1 Baño',
  hero_golfo_size: '90 m² (969 ft²)',

  // Booking Calendar
  booking_subtitle: 'Reserva tu estancia',
  booking_title: 'Reserva tu Villa',
  booking_select_date_title: 'Selecciona una fecha',
  booking_select_date_subtitle: 'Elige la fecha de tu llegada entre las disponibles',
  booking_select_time_title: 'Selecciona un horario',
  booking_select_time_subtitle: 'Elige la franja horaria que mejor te convenga',
  booking_review_title: 'Revisa y envía la solicitud',
  booking_review_subtitle: 'Completa tus datos para enviar tu solicitud de reserva',
  booking_selected_date: 'Fecha seleccionada',
  booking_selected_time: 'Horario',
  booking_modify_time: 'Modificar horario',
  booking_back: 'Atrás',
  booking_name_label: 'Nombre completo',
  booking_name_placeholder: 'Tu nombre',
  booking_phone_label: 'Teléfono',
  booking_phone_placeholder: 'Tu teléfono',
  booking_notes_label: 'Notas (opcional)',
  booking_notes_placeholder: '¿Algo que debamos saber?',
  booking_submit: 'Enviar Solicitud',
  booking_submitting: 'Enviando...',
  booking_success_title: '¡Solicitud enviada!',
  booking_success_message: '¡Gracias! Hemos recibido tu solicitud. Tu reserva aún no está confirmada — te enviaremos un email para confirmar la disponibilidad.',
  booking_book_another: 'Hacer otra reserva',
  booking_loading: 'Cargando disponibilidad...',
  booking_error: 'No pudimos cargar la disponibilidad. Inténtalo de nuevo.',
  booking_retry: 'Reintentar',
  booking_no_slots: 'No hay horarios disponibles para esta fecha.',
  booking_prev_month: 'Mes anterior',
  booking_next_month: 'Mes siguiente',
  booking_required_name: 'Por favor, introduce tu nombre.',
  booking_required_phone: 'Por favor, introduce tu teléfono.',
  booking_required_email: 'Por favor, introduce tu email.',
  booking_invalid_email: 'Por favor, introduce un email válido.',
  booking_week_sun: 'Dom',
  booking_week_mon: 'Lun',
  booking_week_tue: 'Mar',
  booking_week_wed: 'Mié',
  booking_week_thu: 'Jue',
  booking_week_fri: 'Vie',
  booking_week_sat: 'Sáb',
  booking_month_jan: 'Enero',
  booking_month_feb: 'Febrero',
  booking_month_mar: 'Marzo',
  booking_month_apr: 'Abril',
  booking_month_may: 'Mayo',
  booking_month_jun: 'Junio',
  booking_month_jul: 'Julio',
  booking_month_aug: 'Agosto',
  booking_month_sep: 'Septiembre',
  booking_month_oct: 'Octubre',
  booking_month_nov: 'Noviembre',
  booking_month_dec: 'Diciembre',

  // Villa Booking (date range)
  booking_step_dates: 'Fechas',
  booking_step_details: 'Detalles',
  booking_select_dates_title: 'Elige tus fechas',
  booking_select_dates_subtitle: 'Selecciona tu fecha de entrada y salida entre las disponibles',
  booking_pick_checkin: 'Selecciona tu fecha de entrada',
  booking_pick_checkout: 'Ahora selecciona tu fecha de salida',
  booking_check_in_label: 'Entrada',
  booking_check_out_label: 'Salida',
  booking_night_singular: 'noche',
  booking_night_plural: 'noches',
  booking_email_label: 'Email',
  booking_email_placeholder: 'Tu email',
  booking_continue: 'Continuar',
  booking_clear: 'Limpiar selección',
  booking_invalid_range: 'El rango seleccionado incluye fechas no disponibles.',
  booking_legend_available: 'Disponible',
  booking_legend_booked: 'Ocupado',
  booking_legend_selected: 'Seleccionado',
  booking_total: 'Total',
  booking_not_confirmed: 'Ten en cuenta: tu reserva no está confirmada hasta que recibas un email de confirmación nuestro.',
};